import { ApiService } from "./ApiService";
import { IPaginatedReq, IUserFull } from "../models";
import { BuyerRoles, BuyerStatus } from "../types";
import { BuyersStep } from "../../v2/consts/enums";

export interface IBuyer extends IPaginatedReq {
  role?: BuyerRoles;
  acquisitions_projected?: string;
  acquisitions_previously?: string;
  location?: string;
  valuation?: number;
  trailing_profit?: number;
  trailing_revenue?: number;
  debt_finance?: number;
  description?: string;
  keywords?: string;
  buyer_type?: string;
  status?: BuyerStatus;
}

export enum BuyerPlanStatus {
  "FREE" = "Basic",
  "STARTER" = "Starter Pro",
  "ADVANCED" = "Advanced Pro",
}

export const BuyerService = {
  GetBuyer: () => {
    return ApiService.Get("/v2/buyer/").then((res) => res);
  },
  PatchBuyer: (data: IBuyer) => {
    return ApiService.Patch("/v2/buyer/", data).then((res) => res);
  },
  GetStep: (step?: BuyersStep) => {
    if (step === BuyersStep.TYPE) return ApiService.Get("/v2/buyer/type/");
    if (step === BuyersStep.LOCATION)
      return ApiService.Get("/v2/buyer/location/");
    if (step === BuyersStep.CATEGORY)
      return ApiService.Get("/v2/buyer/category/");
    if (step === BuyersStep.ACQUISITION_BUDGET)
      return ApiService.Get("/v2/buyer/acquisition-budget/");
    if (step === BuyersStep.SHORT_BIO)
      return ApiService.Get("/v2/buyer/short-bio/");
    if (step === BuyersStep.SEARCH_INTEREST)
      return ApiService.Get("/v2/buyer/search-interest/");
    return ApiService.Get("/v2/buyer/");
  },
  GetBuyerStatus: (user: IUserFull): BuyerPlanStatus | undefined => {
    const userPlan = user.subscription_plan;

    if (userPlan === "free") {
      return BuyerPlanStatus.FREE;
    }
    if (userPlan === "starter") {
      return BuyerPlanStatus.STARTER;
    }
    if (userPlan === "advanced") {
      return BuyerPlanStatus.ADVANCED;
    }
    return BuyerPlanStatus.FREE;
  },
  GetListingViewsCountUnviewed: () => {
    return ApiService.Get("/v2/buyer/listing-views-count/").then((res) => res);
  },
};
